import { render, staticRenderFns } from "./OlabPackageSVGGen.vue?vue&type=template&id=1c96d781&"
import script from "./OlabPackageSVGGen.vue?vue&type=script&lang=js&"
export * from "./OlabPackageSVGGen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports